import { createSelector } from 'reselect'

const root = (state) => state.get('unread')
const byConversationId = (state) => root(state).get('lastMessageByConversationId')

export const unreadConversationIds = createSelector(
  byConversationId,
  (byConversationId) => {
    return byConversationId.filter(lastMessage => {
      const sentAt = lastMessage.get('sentAt')
      const readAt = lastMessage.get('readAt')

      if (sentAt && !readAt) {
        return true
      }

      return readAt < sentAt
    }).keySeq()
  })

export const makeLastMessageUnread = () => createSelector(
  byConversationId,
  (state, { conversationId }) => conversationId,
  (byConversationId, conversationId) => {
    const sentAt = byConversationId.getIn([conversationId, 'sentAt'])
    const readAt = byConversationId.getIn([conversationId, 'readAt'])

    if (sentAt && !readAt) {
      return true
    }

    return readAt < sentAt
  })



// WEBPACK FOOTER //
// ./src/scripts/app/modules/unread/selectors.js